import { JDSTableRowProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSTableRowProps>
  ): React.FC<JDSTableRowProps> =>
  (props: JDSTableRowProps) => {
    return <Component {...props} />;
  };
